module.exports = "/_next/static/images/ameer-74181ebf5723486f7ebbdfe4326f5ab9.png";